export const authFieldSx = {
  "& .MuiOutlinedInput-root, &.MuiOutlinedInput-root": {
    bgcolor: "#fff",
    borderColor: "#f7b900",
    "& fieldset": { borderColor: "#f7b900" },
    "&:hover": { borderColor: "#dfa700" },
    "&:hover fieldset": { borderColor: "#dfa700" },
    "&.Mui-focused": {
      borderColor: "#d99f00",
      boxShadow: "0 0 0 3px rgba(247, 185, 0, 0.16)",
    },
    "&.Mui-focused fieldset": { borderColor: "#d99f00" },
    "&.Mui-error": {
      borderColor: "#d32f2f",
      boxShadow: "none",
    },
    "&.Mui-error fieldset": { borderColor: "#d32f2f" },
    "&.Mui-disabled": {
      bgcolor: "#fffaf0",
      borderColor: "#f7b900",
      color: "#5f5f5f",
    },
    "&.Mui-disabled fieldset": { borderColor: "#f7b900" },
    "& .Mui-disabled": {
      WebkitTextFillColor: "#5f5f5f",
    },
  },
  "& .MuiInputLabel-root": { color: "#b47d00" },
  "& .MuiInputLabel-root.Mui-focused": { color: "#a56f00" },
  "& .MuiSelect-icon": {
    border: "none",
    outline: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
    color: "text.secondary",
    right: 8,
    transition: "transform 160ms ease, color 160ms ease",
  },
  "& .MuiSelect-iconOpen": {
    color: "#a56f00",
    transform: "rotate(180deg)",
  },
  "& .MuiAutocomplete-popupIndicator": {
    border: "none",
    outline: "none",
    boxShadow: "none",
    backgroundColor: "transparent",
    color: "text.secondary",
    transition: "transform 160ms ease, color 160ms ease",
  },
  "& .MuiAutocomplete-popupIndicator:hover": {
    backgroundColor: "transparent",
  },
  "& .MuiAutocomplete-popupIndicator.Mui-focusVisible": {
    outline: "none",
    boxShadow: "none",
  },
  "& .MuiAutocomplete-popupIndicatorOpen": {
    color: "#a56f00",
    transform: "rotate(180deg)",
  },
  "& input:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 1000px #fff inset",
    WebkitTextFillColor: "#171717",
    caretColor: "#171717",
    transition: "background-color 9999s ease-out 0s",
  },
  "& input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
    WebkitBoxShadow: "0 0 0 1000px #fff inset",
    WebkitTextFillColor: "#171717",
  },
};
